import range from 'lodash-es/range'

import type { OrderOffer } from '@fourthwall/services/dist/models/order'

export const flattenOffers = (offers?: OrderOffer[]): OrderOffer[] => {
  if (!offers) {
    return []
  }

  return offers.reduce((accumulator: OrderOffer[], currentOffer) => {
    return [
      ...accumulator,
      ...range(currentOffer.quantity).map(() => ({ ...currentOffer, quantity: 1 })),
    ]
  }, [])
}
